export default __webpack_public_path__ + "static/media/shareLink.762a46eb.svg";